import { useLocation } from 'react-router-dom';
import Tasks from '../../components/Tasks';
import { useState, useEffect } from 'react';

const VerticalsPage = () => {
  const location = useLocation();
  const [title, setTitle] = useState('');

  useEffect(() => {
    const path = location.pathname.split('/').pop();
    let pageTitle;

    if (path === 'draft-verticals') {
      pageTitle = 'Private Verticals';
    }
    if (path === 'my-verticals') {
      pageTitle = 'My Verticals';
    }
    if (path === 'joined-verticals') {
      pageTitle = 'Joined Verticals';
    }

    setTitle(pageTitle);
    document.title = `${pageTitle} - The Simple Platform`;
  }, [location.pathname]);

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>{title}</h2>
      </div>

      <div>{<Tasks activeTab={title} />}</div>
    </div>
  );
};
export default VerticalsPage;
